import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ThemeProvider } from '@mui/material/styles';
import theme from 'styles/theme';
import CssBaseline from '@mui/material/CssBaseline';
import Main from './Main';

import DocumentProvider from './context/DocumentProvider';

// Test comment

const App = ({
  ehrRecord,
  requestPatientRecord,
  isNewRecordAvailable,
  getPatientAttachment,
  exportCDAAsPDF,
  exportCDAAsPDFLoading,
  setExportCDAAsPDFLoading
}) => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {ehrRecord ? (
          <DocumentProvider>
            <AnimatePresence>
              <Routes>
                <Route
                  exact={ehrRecord ? false : true}
                  path="/"
                  element={
                    <Main
                      ehrRecord={ehrRecord}
                      requestPatientRecord={requestPatientRecord}
                      isNewRecordAvailable={isNewRecordAvailable}
                      getPatientAttachment={getPatientAttachment}
                      exportCDAAsPDF={exportCDAAsPDF}
                      exportCDAAsPDFLoading={exportCDAAsPDFLoading}
                      setExportCDAAsPDFLoading={setExportCDAAsPDFLoading}
                    />
                  }
                />
              </Routes>
            </AnimatePresence>
          </DocumentProvider>
        ) : (
          <Router>
            <DocumentProvider>
              <AnimatePresence>
                <Routes>
                  <Route
                    exact={ehrRecord ? false : true}
                    path="/"
                    element={
                      <Main
                        ehrRecord={ehrRecord}
                        requestPatientRecord={requestPatientRecord}
                        isNewRecordAvailable={isNewRecordAvailable}
                        getPatientAttachment={getPatientAttachment}
                        exportCDAAsPDF={exportCDAAsPDF}
                        exportCDAAsPDFLoading={exportCDAAsPDFLoading}
                        setExportCDAAsPDFLoading={setExportCDAAsPDFLoading}
                      />
                    }
                  />
                </Routes>
              </AnimatePresence>
            </DocumentProvider>
          </Router>
        )}
      </ThemeProvider>
    </>
  );
};

export default App;
